import React, { forwardRef } from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { StyledImg } from '../common';

export type ImageAlignLargeImageCard =
  | 'left'
  | 'right'
  | 'leading'
  | 'trailing';

export type HorizontalLargeImageCardProps = {
  image: string;
  imageAltText: string;
  children: React.ReactElement;
  imageAlign?: ImageAlignLargeImageCard;
  imageLoading?: 'lazy' | 'eager';
};

export const HorizontalLargeImageCard = forwardRef<
  HTMLDivElement,
  HorizontalLargeImageCardProps
>(
  (
    {
      image,
      imageAltText,
      children,
      imageAlign = 'left',
      imageLoading = 'lazy',
    },
    ref,
  ) => {
    const isImageAlignLeading =
      imageAlign === 'left' || imageAlign === 'leading';

    return (
      <StackLayout
        orientation="horizontal"
        horizontalAlignment="spaceBetween"
        spacing="$oneAndHalf"
        verticalAlignment="center"
        css={{ flexFlow: isImageAlignLeading ? 'row-reverse' : 'row' }}
        ref={ref}
      >
        {children}
        <StyledImg
          borderStartStartRadius={isImageAlignLeading && 'medium'}
          borderEndStartRadius={isImageAlignLeading && 'medium'}
          borderStartEndRadius={!isImageAlignLeading && 'medium'}
          borderEndEndRadius={!isImageAlignLeading && 'medium'}
          borderStyle="solid"
          src={image}
          width="350px"
          minHeight="176px"
          height="100%"
          alt={imageAltText}
          loading={imageLoading}
        />
      </StackLayout>
    );
  },
);
